const safeProducts = [
  {
    id: 1,
    title: "SafeSnuggle Anti-Fall Pillow 🛌",
    handle: "safesnuggle-anti-fall-pillow-for-babies",
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1735662857771.png?v=1735663295",
    variants: [
      { name: "Pink Soft Velvet", id: "47655345750297", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1735662857771.png?v=1735663295" },
      { name: "Blue Soft Velvet", id: "47655345783065", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1735662838602.png?v=1735663323" },
      { name: "Pink Breathable", id: "50162284364057", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_04030449-c2d9-4ac9-b5b9-3988b5c5902d.png?v=1704385679" },
      { name: "Blue Breathable", id: "50162284396825", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_b7d2f8a1-c5d4-4bb3-accb-e5595f822394.png?v=1704385679" }
    ]
  },
  {
    id: 2,
    title: "Stroller Hooks 🛒",
    handle: "stroller-hooks",
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_612eb216-621d-4f70-bbcd-481be3b9ff64.png?v=1756297277",
    variants: [
      { name: "Black", id: "52303112601881", price: 3.00, comparePrice: 5.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_612eb216-621d-4f70-bbcd-481be3b9ff64.png?v=1756297277" }
    ]
  },
  {
    id: 3,
    title: "GlowRing™ 💡",
    handle: "glowring",
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_621528dd-c77d-4807-b3a6-506afecb6538.webp?v=1778527865",
    variants: [
      { name: "Standard", id: "52390824083737", price: 1.47, comparePrice: 1.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_621528dd-c77d-4807-b3a6-506afecb6538.webp?v=1778527865" }
    ]
  },
  {
    id: 4,
    title: "BedBuddy™ 🛏️",
    handle: "bedbuddy",
    defaultImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259",
    variants: [
      { name: "Pink", id: "52376380539161", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" },
      { name: "Blue", id: "52376380571929", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" },
      { name: "Grey", id: "52376380604697", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" },
      { name: "White", id: "52380600008985", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" },
      { name: "Black", id: "52380600533273", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" }
    ]
  }
];

let safeStockSynced = false;

async function syncSafeShopifyStock() {
  for (const product of safeProducts) {
    try {
      const res = await fetch(`/products/${product.handle}.js`);
      if (!res.ok) continue;

      const data = await res.json();

      product.variants.forEach(variant => {
        const liveVariant = data.variants.find(v => String(v.id) === String(variant.id));
        if (liveVariant) {
          variant.inStock = liveVariant.available;
          variant.price = liveVariant.price / 100;
          variant.comparePrice = liveVariant.compare_at_price ? liveVariant.compare_at_price / 100 : null;
        }
      });
    } catch (error) {
      console.warn("Stock/price sync failed:", product.title);
    }
  }
  safeStockSynced = true;
}

function getSafeSavePercentage(price, comparePrice) {
  if (!comparePrice || comparePrice <= price) return null;
  return Math.round(((comparePrice - price) / comparePrice) * 100);
}

function getSafeDefaultVariant(product) {
  if (product.defaultVariantId) {
    const chosen = product.variants.find(v => String(v.id) === String(product.defaultVariantId));
    if (chosen && chosen.inStock) return chosen;
  }
  return product.variants.find(v => v.inStock) || product.variants[0];
}

function renderSafeProducts() {
  const grid = document.getElementById("safeGrid");
  if (!grid) return;

  grid.innerHTML = "";

  safeProducts.forEach(product => {
    const firstVariant = getSafeDefaultVariant(product);
    const displayImage = product.defaultImage || firstVariant.image;
    const savePercent = getSafeSavePercentage(firstVariant.price, firstVariant.comparePrice);

    const card = document.createElement("article");
    card.className = "safe-card";

    let dropdownOptions = "";

    product.variants.forEach(variant => {
      const selected = String(variant.id) === String(firstVariant.id) ? "selected" : "";
      const soldOutClass = !variant.inStock ? "sold-out-option" : "";

      dropdownOptions += `
        <option
          value="${variant.id}"
          data-price="${variant.price}"
          data-compare="${variant.comparePrice || ""}"
          data-image="${variant.image}"
          data-title="${product.title}"
          data-instock="${variant.inStock}"
          class="${soldOutClass}"
          ${selected}>
          ${variant.name}
        </option>
      `;
    });

    card.innerHTML = `
      <div class="safe-card-image-container">
        ${savePercent ? `<span class="sale-badge">SAVE ${savePercent}%</span>` : ""}

        <img src="${displayImage}" alt="${product.title}" class="safe-card-image" loading="lazy">

        <div class="image-overlay">
          <a href="/products/${product.handle}" class="view-details-btn">
            <svg viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/>
            </svg>
            <span>View Details</span>
          </a>
        </div>

        <button class="image-cart-btn add-to-cart-mobile ${!firstVariant.inStock ? "sold-out-mobile" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
        </button>

        ${!firstVariant.inStock ? `<div class="mobile-sold-out">Sold Out</div>` : ""}
      </div>

      <div class="safe-card-info">
        <h3 class="safe-card-title">${product.title}</h3>

        <div class="variant-selector">
          <select class="variant-dropdown ${!firstVariant.inStock ? "selected-sold-out" : ""}">
            ${dropdownOptions}
          </select>
        </div>

        <div class="safe-card-price">
          <span class="current-price">$${firstVariant.price.toFixed(2)}</span>
          ${firstVariant.comparePrice ? `<span class="compare-price">$${firstVariant.comparePrice.toFixed(2)}</span>` : ""}
        </div>

        <button class="add-to-cart-btn add-to-cart-desktop ${!firstVariant.inStock ? "sold-out" : ""}"
          data-variant-id="${firstVariant.id}"
          data-title="${product.title}"
          data-price="${firstVariant.price}"
          data-image="${displayImage}"
          ${!firstVariant.inStock ? "disabled" : ""}>
          <svg viewBox="0 0 24 24">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          <span>${firstVariant.inStock ? "Add to Cart" : "Sold Out"}</span>
        </button>
      </div>
    `;

    grid.appendChild(card);
  });

  attachSafeEventListeners();
}

function attachSafeEventListeners() {
  document.querySelectorAll(".variant-dropdown").forEach(dropdown => {
    dropdown.addEventListener("change", function () {
      const card = this.closest(".safe-card");
      const option = this.options[this.selectedIndex];

      const variantId = option.value;
      const price = parseFloat(option.dataset.price);
      const compare = option.dataset.compare ? parseFloat(option.dataset.compare) : null;
      const image = option.dataset.image;
      const productTitle = option.dataset.title;
      const inStock = option.dataset.instock === "true";

      const imageEl = card.querySelector(".safe-card-image");
      const priceEl = card.querySelector(".current-price");
      const compareEl = card.querySelector(".compare-price");
      const desktopBtn = card.querySelector(".add-to-cart-desktop");
      const mobileBtn = card.querySelector(".add-to-cart-mobile");
      const imageContainer = card.querySelector(".safe-card-image-container");

      imageEl.src = image;
      priceEl.textContent = `$${price.toFixed(2)}`;

      if (compareEl) {
        if (compare && compare > price) {
          compareEl.textContent = `$${compare.toFixed(2)}`;
          compareEl.style.display = "inline";
        } else {
          compareEl.style.display = "none";
        }
      }

      desktopBtn.dataset.variantId = variantId;
      desktopBtn.dataset.price = price;
      mobileBtn.dataset.variantId = variantId;
      mobileBtn.dataset.price = price;

      const existingBadge = card.querySelector(".mobile-sold-out");

      if (inStock) {
        this.classList.remove("selected-sold-out");

        desktopBtn.disabled = false;
        desktopBtn.classList.remove("sold-out");
        desktopBtn.querySelector("span").textContent = "Add to Cart";

        mobileBtn.disabled = false;
        mobileBtn.classList.remove("sold-out-mobile");

        if (existingBadge) existingBadge.remove();
      } else {
        this.classList.add("selected-sold-out");

        desktopBtn.disabled = true;
        desktopBtn.classList.add("sold-out");
        desktopBtn.querySelector("span").textContent = "Sold Out";

        mobileBtn.disabled = true;
        mobileBtn.classList.add("sold-out-mobile");

        if (!existingBadge) {
          const badge = document.createElement("div");
          badge.className = "mobile-sold-out";
          badge.textContent = "Sold Out";
          imageContainer.appendChild(badge);
        }
      }
    });
  });

  document.querySelectorAll(".add-to-cart-desktop").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });

  document.querySelectorAll(".add-to-cart-mobile").forEach(button => {
    button.addEventListener("click", function () {
      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const title = this.dataset.title;
      const price = parseFloat(this.dataset.price);
      const image = this.dataset.image;

      if (typeof window.addToCart === "function") {
        window.addToCart({
          variant_id: variantId,
          title: title,
          price: price,
          quantity: 1,
          image: image
        });
      } else {
        console.error("window.addToCart is not available");
        alert("Cart is not ready. Please refresh the page.");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  renderSafeProducts();
  syncSafeShopifyStock().then(function () {
    renderSafeProducts();
  });
});